import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';

interface WaterLevelIconProps {
  waterPercent: number;
  // Explicit width/height in px; omitted, the icon keeps its native size.
  size?: number;
}
export const RobotWaterLevelIcon = ({ waterPercent, size }: WaterLevelIconProps): JSX.Element => {
  switch (true) {
    case waterPercent === 100:
      return <SvgIcon name="water100Percent" size={size} />;
    case waterPercent >= 75:
      return <SvgIcon name="water75Percent" size={size} />;
    case waterPercent >= 50:
      return <SvgIcon name="water50Percent" size={size} />;
    case waterPercent >= 25:
      return <SvgIcon name="water25Percent" size={size} />;
    case waterPercent === 0:
      return <SvgIcon name="water00Percent" size={size} />;
    default:
      return <SvgIcon name="water00Percent" size={size} />;
  }
};
